import { OAUTH_CONSENT_PATH } from "@platform/core";

const ROUTES = {
  Accounts: "/accounts",
  AuthCallback: "/auth/callback",
  Dashboard: "/",
  Maintenance: "/maintenance",
  Metrics: "/metrics",
  OAuthConsent: OAUTH_CONSENT_PATH,
  Playground: "/playground",
  Signin: "/auth/signin",
  Tables: "/tables",
} as const;

export type Route = keyof typeof ROUTES;

export const router = {
  getPattern: (route: Route): string => ROUTES[route],
  getUrl: (route: Route): string => ROUTES[route],
} as const;
